<section class="playground">
  <h2 class="playground__heading">Toggle</h2>
  <p class="playground__hint">
    <code>common-toggle</code> — <code>mat-slide-toggle</code> con estilos del DS.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>label</span>
        <input type="text" [(ngModel)]="label" />
      </label>
      <label class="playground__field">
        <span>color</span>
        <select [(ngModel)]="color">
          <option *ngFor="let c of colors" [value]="c">{{ c }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>labelPosition</span>
        <select [(ngModel)]="labelPosition">
          <option *ngFor="let p of positions" [value]="p">{{ p }}</option>
        </select>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="checked" />
        <span>checked</span>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-toggle
          [label]="label"
          [(ngModel)]="checked"
          [disabled]="disabled"
          [color]="color"
          [labelPosition]="labelPosition"
          (change)="onChange($event)"
        ></common-toggle>
      </div>
      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
